/* eslint-disable no-console */
import React, { useState } from 'react';
import * as env from 'config/environment';
import * as api from 'config/api';
import Modal2 from 'components/commons/modal/Modal2';
import Loading from 'components/commons/loading/Loading';
import {
  getViewedWebPushStorage,
  updateRegisteredWebPush,
  updateViewedWebPush,
  updateViewedWebPushDailyReport,
  updateViewedWebPushSecurityAccounts,
} from 'utils/storage';
import { useLocation } from 'react-router-dom';

const updateViewedWebPushStorage = (path: string) => {
  const viewedWebPush = getViewedWebPushStorage();
  if (path === '/dailyreport') {
    if (viewedWebPush) {
      updateViewedWebPushDailyReport(true);
    } else {
      updateViewedWebPush(true, false);
    }
  }

  if (path === '/securityaccounts') {
    if (viewedWebPush) {
      updateViewedWebPushSecurityAccounts(true);
    } else {
      updateViewedWebPush(false, true);
    }
  }
};

export const NoticeSettingModal = ({
  isShow,
  hide,
}: {
  isShow: boolean;
  hide: () => void;
}) => {
  const location = useLocation();
  const path = location.pathname;

  const [isReceiving, setIsReceiving] = useState<boolean>(false);

  const receiveNotifications = (): void => {
    if (isReceiving) return;
    setIsReceiving(true);

    if (!('Notification' in window)) {
      hide();
      updateViewedWebPushStorage(path);
    } else {
      window.Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          // ブラウザポップアップで許可時の処理
          if (!('serviceWorker' in navigator)) {
            hide();
            updateViewedWebPushStorage(path);
          } else {
            navigator.serviceWorker.ready.then(registration => {
              registration.pushManager
                .subscribe({
                  userVisibleOnly: true,
                  applicationServerKey: env.webPushPublickKey,
                })
                // TODO: 適切な型があれば変える
                .then((pushSubscription: { toJSON: () => any }) => {
                  const subscriptionJSON = pushSubscription.toJSON();

                  api
                    .RegisterUserWebPushInfo({
                      endPoint: subscriptionJSON.endpoint ?? '',
                      publicKey: subscriptionJSON.keys
                        ? subscriptionJSON.keys.p256dh
                        : '',
                      authInfo: subscriptionJSON.keys
                        ? subscriptionJSON.keys.auth
                        : '',
                    })
                    .then(ret => {
                      if (!ret.Success) {
                        alert(`通信に失敗しました、再度お試しください`);
                        hide();
                        return;
                      }

                      updateRegisteredWebPush(true);
                      updateViewedWebPushStorage(path);
                      hide();
                    });
                });
            });
          }
        } else {
          updateRegisteredWebPush(false);
          updateViewedWebPushStorage(path);
          hide();
        }
      });
    }
    setIsReceiving(false);
  };

  const onClose = () => {
    if (isReceiving) return;

    updateRegisteredWebPush(false);
    updateViewedWebPushStorage(path);
    hide();
  };

  return (
    <Modal2 isShow={isShow}>
      <div className="max-h-modal overflow-y-auto text-bluegray-700 relative">
        <div className="w-full h-full">
          <img
            src="/static/images/web_push/push_notice.png"
            alt=""
            className="w-full h-full"
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div
          className="icon-close ml-auto text-white text-2xl absolute cursor-pointer"
          style={{ top: '2%', right: '2%' }}
          onClick={onClose}
        />
        <div className="p-4">
          <div className="flex items-end justify-center justify-items-center mb-auto app-primary-label-block">
            <div className="inline-flex items-center flex-col text-bluegray-700 text-sm font-bold">
              プッシュ通知ですぐにわかる
            </div>
          </div>
          <div className="mt-1 text-lg font-bold text-center">
            「口座連携の完了」
            <br />
            「大きな資産変動があった時」
            <br />
            にお知らせします
          </div>
          <div
            className="flex flex-row justify-center mt-5 py-2 px-4 font-bold text-blue-700 bg-gray-50 border border-blue-700 rounded-lg shadow cursor-pointer"
            onClick={receiveNotifications}>
            通知を受け取る
          </div>
          <div
            className="flex flex-row justify-center mt-5 mb-4 py-2 px-4 text-sm text-bluegray-500 cursor-pointer"
            onClick={onClose}>
            今回は受け取らない
          </div>
        </div>
      </div>
      {isReceiving && (
        <div className="absolute top-0 left-0 h-full w-full bg-gray-700 opacity-75 flex justify-center items-center">
          <Loading
            loading={true}
            circularLoading={true}
            style={{
              backgroundColor: 'transparent',
            }}
          />
        </div>
      )}
    </Modal2>
  );
};
